import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";

const ShopToggle = forwardRef(({
  name,
  onChange,
  className,
  labelClassName,
  defaultChecked,
  ...props
}, ref) => {
  const [checkboxValue, setCheckboxValue] = useState((defaultChecked === "on" || defaultChecked == "1") ? "on" : (defaultChecked === "off" || defaultChecked == "0") ? "off" : defaultChecked);

  return (
    <>
      <label 
        className={`${className}`}
      >
        <div className="flex flex-row justify-between items-center">
          <div className="relative w-[51px] h-[31px]">
            <input
              name={name}
              onChange={(e) => {
                const value = e.target.checked ? "on" : "off";
                setCheckboxValue(value);
                if (onChange) {
                  onChange(e);
                }
              }}
              ref={ref}
              checked={(defaultChecked === "on" || defaultChecked == "1") ? 1 : (defaultChecked === "off" || defaultChecked == "0") ? 0 : defaultChecked}
              {...props}
              type="checkbox"
              className="peer hidden"
            />
            <span
              className={`
                absolute cursor-pointer top-0 left-0 right-0 bottom-0 bg-[rgba(120,120,128,0.16)] rounded-[100px] w-[51px] h-[31px] transition-all duration-500
                peer-disabled:opacity-40 peer-disabled:cursor-not-allowed 
                peer-checked:bg-sportsYellow peer-checked:before:left-[calc(100%-29px)]
                before:absolute before:top-[2px] before:left-[2px] before:transition-all before:h-[27px] before:w-[27px] before:rounded-full before:bg-white before:shadow-[0_3px_1px_0_rgba(0,0,0,0.06),0_3px_8px_0_rgba(0,0,0,0.15),0_0_0_1px_rgba(0,0,0,0.04)] before:duration-300
              `}
            ></span>
          </div>
        </div>
      </label>
      <input type="hidden" name={`${name}Value`} value={checkboxValue} />
    </>
  );
});

ShopToggle.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default ShopToggle;